module.exports = __webpack_public_path__ + "img/Step3.f4359184.png";